<template>
  <v-autocomplete
      class="small-text-field"
      :value="preassignedDriver"
      :label="label"
      :items="items"
      :v-model="preassignedDriver"
      item-value="id"
      item-name="id"
      item-text="idname"
      @input="updateSelf"
      :height="28"
      placeholder="Begin typing name"
      :hide-details="valid() == true && (error == null || error.length == 0)"
      :error-messages="valid() == true ? null : [valid()] "
      :loading="loading"
      @focus="focused"
      outlined
      dense
      style="width: 240px;"
  >
    <template v-slot:selection="{ item, index }">
      <span style="font-size: 12px !important;" v-html="htmlForDriver(item)"></span>
    </template>
    <template v-slot:item="{ item, index }">
      <span style="font-size: 12px !important;" v-html="htmlForDriver(item)"></span>
    </template>
  </v-autocomplete>
</template>

<script>
import moment from "moment";

export default {
  name: "SelectableDriverInput",
  model: {
    prop: "preassignedDriver",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    preassignedDriver: Number,
    bookingForm: Object,
    error: String
  },
  computed: {
    items: function() {
      return this.bookingForm.booking.eligibleDriversForPreassign;
    }
  },
  data() {
    return {
      menu: false,
      drivers: [],
      loading: false
    };
  },
  methods: {
    callsignPrefixForDriver(driver) {
      var group = "";


      for (var i = 0; i < this.$store.state.driverGroups.length; i++) {
        if (driver.driver_group_id == this.$store.state.driverGroups[i].id) {
          group = this.$store.state.driverGroups[i].callsignPrefix;
        }
      }

      
      return group;
    },
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    willBeActive(p) {
      return this.bookingForm.promocodeWillBeActive(p);
    },
    htmlForDriver(item) {
      return (
          "<p><b>" + this.callsignPrefixForDriver(item) + item.callsign + "&nbsp;-&nbsp;</b>" + item.name + "</p>"
      );
    },
    htmlForPromocodeExtended(item) {
      return (
          "<p><b>" +
          item.promocode.code +
          "</b><br>" +
          item.promocode.promotion.description
      );
    },
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");

      this.bookingForm.getEligibleDriversForPreassign();

      this.$forceUpdate();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
